frappe.ui.form.ControlAbsCurrency = class ControlAbsCurrency extends frappe.ui.form.ControlCurrency {
    make_input() {
        super.make_input();

        var me = this;

        // Ensure the field always displays a positive number when focused
        this.$input.on("focus", function () {
            setTimeout(function () {
                if (!document.activeElement) return;
                // Always show the absolute value on focus
                document.activeElement.value = Math.abs(me.validate(document.activeElement.value));
                document.activeElement.select();
            }, 100);
            return false;
        });

        this.$input.on("focusout", (e) => {
            let value = this.get_input_value();
            this.parse_validate_and_set_in_model(value, e);
            this.refresh();
        });
    }

    validate(value) {
        return this.parse(value);
    }

    parse(value) {
        let parsed_value = this.eval_expression(value);
        parsed_value = isNaN(parseFloat(parsed_value)) ? null : flt(parsed_value, this.get_precision());
        return parsed_value ? -Math.abs(parsed_value) : 0;  // Always store as negative
    }

    format_for_input(value) {
        if (!value) return "";

        var formatted_value = format_number(Math.abs(value), this.get_number_format(), this.get_precision()); // Show positive
        return formatted_value;
    }

    format(value) {
        // Ensure the UI always displays a positive value in grid view
        return value == null || value === "" ? "" : format_number(Math.abs(value), this.get_number_format(), this.get_precision());
    }

    get_precision() {
        // Always round based on field precision or currency's precision
        if (!this.df.precision) {
            if (frappe.boot.sysdefaults.currency_precision) {
                this.df.precision = frappe.boot.sysdefaults.currency_precision;
            } else {
                this.df.precision = get_number_format_info(this.get_number_format()).precision;
            }
        }

        return this.df.precision;
    }
};

// Register the new control field
frappe.ui.form.ControlNegativeCurrency = frappe.ui.form.ControlAbsCurrency;
